import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {CANCEL_CONTRACT_PATH} from "../contracts/contractCancellationRoutes";
import {CancelContractPage} from "../contracts/CancelContractPage";

/**
 * Public, pre-rendered § 312k BGB cancellation page (`/cancel-contract`, kitecorp/transferify-ui#2327).
 *
 * <p>PRE-RENDERED rather than client-only, which is the opposite of every other route that holds a form
 * writing to an account. § 312k Abs. 2 S. 4 requires the page to be "ständig verfügbar sowie unmittelbar und
 * leicht zugänglich", and the German courts have struck down every arrangement that put a session between the
 * consumer and this page. A pre-rendered route answers a direct hit with real HTML and a 200 to anyone,
 * including a crawler and a regulator, so it must never be added to `CLIENT_ONLY_ROUTE_SEGMENTS`.
 *
 * <p>Indexable on purpose too. The page is how a consumer finds the control when they cannot find the menu,
 * which is the "leicht zugänglich" complaint LG München I upheld against a footer link buried among many.
 */
export function Component() {
	const {cancellation} = useMessages();
	return (
		<>
			<Seo
				title={cancellation.seoTitle}
				description={cancellation.seoDescription}
				path={CANCEL_CONTRACT_PATH}
			/>
			<CancelContractPage/>
		</>
	);
}
